import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { MARKETING_EMAIL_TYPE_ID, MARKETING_SMS_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const SUPPORTED_OBJECTS = {
  [MARKETING_EMAIL_TYPE_ID]: {
    contentPropertyName: 'hs_origin_asset_id'
  },
  [MARKETING_SMS_TYPE_ID]: {
    contentPropertyName: 'hs_content_id'
  }
};
function getIDFilter({
  id
}) {
  return {
    operator: 'EQ',
    property: 'hs_object_id',
    value: id
  };
}
function getContentIDFilter({
  objectTypeId,
  contentId
}) {
  return {
    operator: 'EQ',
    property: SUPPORTED_OBJECTS[objectTypeId].contentPropertyName,
    value: contentId
  };
}
export const SEARCH_CRM_BY_ID = registerQuery({
  fieldName: 'crmSearch',
  args: ['objectTypeId', 'id', 'contentId'],
  fetcher: async ({
    objectTypeId,
    id,
    contentId
  }) => {
    const idFilter = id ? getIDFilter({
      id
    }) : null;
    const contentIdFilter = contentId ? getContentIDFilter({
      objectTypeId,
      contentId
    }) : null;
    const response = await http.post('/crm-search/search', {
      data: {
        count: 1,
        filterGroups: [{
          filters: [idFilter !== null && idFilter !== void 0 ? idFilter : contentIdFilter]
        }],
        objectTypeId,
        offset: 0,
        query: '',
        requestOptions: {
          allPropertiesFetchMode: 'latest_version',
          includeAllProperties: true
        }
      }
    });
    return response;
  }
});